<template>
    <div class="changepassword__wrapper">
        <confirmationDialog
            :dialogStatus="dialogStatus"
            :title="'Change Password'"
            :eventName="'changePasswordEvent'"
            @changePasswordEvent="changePasswordActions"
            :actions="actionsList"
            >
            <v-container class="pa-0">
                <v-layout wrap class="customized-textfield">
                    <v-flex xs12 v-if="fromheader">
                        <label>Old Password*</label>
                        <v-text-field 
                            placeholder="Old Password"
                            solo
                            flat
                            type="password"
                            background-color="#F7F7F7"
                            color="#E34E25"
                            :rules="[rules.required]"
                            v-model ="oldPassword"
                            v-on:keydown.enter.prevent
                            :append-icon="oldPassword ? 'clear' : ''"
                            @click:append="oldPassword = ''"
                            :error-messages="invalidOldPassword ? 'Incorrect old password' : ''">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <label>New Password*</label>
                        <v-text-field 
                            placeholder="New Password"
                            solo
                            flat
                            type="password"
                            background-color="#F7F7F7"
                            color="#E34E25"
                            v-model="newPassword" 
                            v-on:keydown.enter.prevent
                            :append-icon="newPassword ? 'clear' : ''"
                            @click:append="newPassword = ''"
                            :rules="fromheader ? [rules.required, rules.min, rules.strongPassword] : [rules.required]">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <label>Confirm New Password*</label>
                        <v-text-field 
                            placeholder="Confirm New Password"
                            solo
                            flat
                            type="password"
                            background-color="#F7F7F7"
                            color="#E34E25"
                            v-model="cNewPassword" 
                            label="Confirm New Password*" 
                            v-on:keydown.enter.prevent
                            :append-icon="cNewPassword ? 'clear' : ''"
                            @click:append="cNewPassword = ''"
                            :rules="fromheader ? [rules.required, rules.min, rules.np_cnp_match] : [rules.required,rules.np_cnp_match]"
                            :error-messages="invalidCNewPassword ? 'The confirm Password and password you entered don\'t match' : ''">
                        </v-text-field>
                    </v-flex>
                    <span class="error_message pa-2 ml-0" v-show="invalidCNewPassword || invalidOldPassword">{{ invalidOldPassword ? 'Invalid old password' : 'The confirm Password and password you entered don\'t match' }} </span>
                    <span class="error_message pa-2 ml-0" v-show="errorMessage">{{errorMessageDetails}}</span>
                    <span class="successMessage pa-2" v-show="successMessage">Password changed successfully!</span>
                </v-layout>
            </v-container>
         </confirmationDialog>
    </div>
</template>

<script>
import Vue from 'vue';
import {hideLoadIcon,showLoadIcon} from '../assets/utils/load.js';
import confirmationDialog from '../../epsrc/components/common/confirmationDialog';
export default {
    name: 'ChangePasswordVue',
    props:{
        fromheader:{
            type: Boolean,
            default: true
        },
        userID:{
            type: Number,
            default: -1
        },
        schemaName:{
            type: String,
            default: null
        },
        dialogStatus: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            opasswordTypeIcon: true,
            npasswordTypeIcon: true,
            cnpasswordTypeIcon: true,
            oldPassword: "",
            newPassword: "",
            cNewPassword: "",
            invalidOldPassword: false,
            invalidCNewPassword: false,
            easyPassword: false,
            errorMessage: false,
            successMessage: false,
            changePasswordPopup: true,
            hide:null,
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                np_cnp_match: v => v == this.newPassword || ('The confirm Password and password you entered don\'t match'),
                strongPassword: v => new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})").test(v) || ('The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character')
            },
            valid : false,
            actionsList: [
                {'text': 'CANCEL', 'action': 'cancel', 'status': 'enabled'},
                {'text': 'CHANGE PASSWORD', 'action': 'changePassword', 'status': 'enabled'},
            ],
            errorMessageDetails: null
        }
    },
    components: {
        confirmationDialog
    },
    created() {
    },
    watch: {
        otpCode(){
            this.invalidOTP = false;
        },
        oldPassword(){
            this.invalidOldPassword = false;
        },
        newPassword(){
            this.invalidCNewPassword = false;
        },
        cNewPassword(){
            this.invalidCNewPassword = false;
        }
    },
    methods: {
        changePasswordActions(data) {
            var self = this;
            if (data.action == 'changePassword') {
                if (self.fromheader) {
                    self.setPassword();
                } else {
                    self.changeUserPassword(self.userID,self.newPassword,self.schemaName);
                }
            } else {
                self.$emit('close');
            }
        },
        setPassword(){
            var self = this, formData = new FormData(), userData = {};
            self.invalidOldPassword = self.oldPassword.length >= 1 ? false : true;
            self.invalidCNewPassword = self.cNewPassword != self.newPassword;
            self.errorMessage = false;
            self.errorMessageDetails = null;
            userData = {
                'old_password': self.oldPassword,
                'new_password': self.newPassword,
            };

            if(!self.invalidOldPassword && !self.invalidCNewPassword){
                formData.append('json', JSON.stringify(userData));
                showLoadIcon();
                this.$loading(true);
                Vue.http.post('/change_user_password/',formData)
                .then((data) => {
                    try{
                        if(data.status == 201){
                        self.easyPassword = true;
                        setTimeout(function(){
                            self.easyPassword = false;
                            self.changePasswordPopup = false
                        },3000);
                        }else{
                            self.successMessage = true;
                            setTimeout(function(){ 
                                self.successMessage = false;
                                self.changePasswordPopup = false
                                self.$emit('close');
                            }, 3000);
                        }
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    if(error.status == 403) {
                        self.showPasswordUpdationError(error);
                    }else if(error.status == 422){
                            self.errorMessage = true;
                            var errMessage = JSON.parse(error.body)
                            self.errorMessageDetails = errMessage['message'];
                            setTimeout(function(){
                                self.errorMessage = false;
                                self.errorMessageDetails = null;
                            },3000);
                        } else if(error.status == 404) {
                        self.invalidOldPassword = true;
                        setTimeout(function (){
                            self.invalidOldPassword = false;
                            self.invalidCNewPassword = false
                        },3000);
                    }else{
                        self.errorMessage = true;
                        setTimeout(function(){
                            self.errorMessage = false;
                        },3000);
                    }
                    //console.log("api failed with error:" + error)
                });
            }
        },
        showPasswordUpdationError(error) {
            let showPasswordUpdateError = error.data && 
                                            error.data.message &&
                                            error.data.message === "password already exists";
            if (showPasswordUpdateError) {
                this.errorMessage = true;
                this.errorMessageDetails = "You have already used that password, try another."
            } 
        },
        changeUserPassword(userID,newPassword,schemaName){
            var self = this;
            self.errorMessage = false;
            self.errorMessageDetails = null;
            self.invalidCNewPassword = self.cNewPassword != self.newPassword;
            if(self.invalidCNewPassword) return
            var userData = {
                'user_id' : userID,
                'password' : newPassword,
                'schema_name' : schemaName
            };
            showLoadIcon();
            this.$loading(true);
            Vue.http.put('/user/',userData)
            .then((data) => {
                try{
                    if(data.status == 201){
                    setTimeout(function(){
                       changePasswordPopup = false
                    },3000);
                    }else{
                        self.successMessage = true;
                        setTimeout(function(){ 
                            self.successMessage = false;
                            self.changePasswordPopup = false
                            self.$emit('close');
                        }, 3000);
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                console.log(error);
                if(error.status == 403) {
                    self.showPasswordUpdationError(error);
                }else if(error.status == 404) {
                    setTimeout(function (){
                    },3000);
                }else{
                    self.errorMessage = true;
                    setTimeout(function(){
                        self.errorMessage = false;
                    },3000);
                }
                //console.log("api failed with error:" + error)
            });
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
<style lang="scss" scoped>
.changepassword__wrapper {
    .v-form {
        width: 90%;
    }
    .v-card__text {
        padding: 0rem;
    }
    .user_creation_popup_div {
        border: none;
    }
    .v-text-field {
		width: 95%;
	}
	.v-input__slot {
        box-sizing: border-box;
		border: 0.5px solid #C6C7C2;
    }
    .v-input--is-focused .v-input__slot {
		border: 0.5px solid #8C857E;
    }
}
</style>